import { api } from '@goaltree/backend/convex/_generated/api'
import {
  PAYWALL_FLAG,
  type PaywallVariant,
  asPaywallVariant,
} from '@goaltree/backend/convex/lib/paywallVariant'
import { useConvexAuth, useMutation, useQuery } from 'convex/react'
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { useEffect } from 'react'

import { posthog } from '@/lib/posthog'

// The arm stored on the user wins (stable across devices); then PostHog's
// assignment; control when PostHog is off or hasn't loaded.
export function usePaywallVariant(): PaywallVariant {
  const { isAuthenticated } = useConvexAuth()
  const prefs = useQuery(api.preferences.getMyPreferences, isAuthenticated ? {} : 'skip')
  const record = useMutation(api.subscriptions.recordPaywallVariant)
  const seen = asPaywallVariant(useFeatureFlagVariantKey(PAYWALL_FLAG))
  const stored = asPaywallVariant(
    (prefs as { paywallVariant?: string } | undefined)?.paywallVariant,
  )
  const variant = stored ?? seen

  useEffect(() => {
    if (isAuthenticated && prefs !== undefined && !stored && seen)
      void record({ variant: seen }).catch(() => {})
  }, [isAuthenticated, prefs === undefined, stored, seen])

  useEffect(() => {
    if (variant) posthog.register({ paywall_variant: variant })
  }, [variant])

  return variant ?? 'control'
}

// For mutations that can complete onboarding: the flag as PostHog has it right now.
export const seenPaywallVariant = () => asPaywallVariant(posthog.getFeatureFlag(PAYWALL_FLAG))
